import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import './_editButtons.scss';

import {Icon} from '@atoms/Media/Icon';
import {Button, ButtonColor, ButtonSize, ButtonType} from '@atoms/LinksAndButtons/Button';
import {Direction, NavArrow} from '@atoms/LinksAndButtons/NavArrow';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic table row data
    object: any;
    lastNumber: number;
    cardView?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic row data
    onDeleteRow?: (data: any) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic row data
    onOrderUp?: (data: any) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic row data
    onOrderDown?: (data: any) => void;
}

export const EditButtons: React.FunctionComponent<Props> = ({object, lastNumber, cardView, onDeleteRow, onOrderDown, onOrderUp}) => {
    const onEditDelete = () => {
        if (onDeleteRow) onDeleteRow(object);
    };
    const onEditUp = () => {
        if (onOrderUp) onOrderUp(object);
    };
    const onEditDown = () => {
        if (onOrderDown) onOrderDown(object);
    };

    return(
        <div className='grid-table__edit'>
            <Button
                className='grid-table__edit--delete'
                icon={<Icon name="delete" />}
                onClick={onEditDelete}
                iconFirst
                iconBtn={!cardView}
                buttonColor={ButtonColor.UNSET} 
                buttonSize={ButtonSize.DEFAULT} 
                buttonType={ButtonType.NO_STYLE} 
            >
                <FormattedMessage id="jm.components.DataTable.delete" />
            </Button>
            <div>
                {cardView && <FormattedMessage id="jm.components.DataTable.move" />}
                <NavArrow
                    small
                    direction={Direction.UP}
                    onClick={onEditUp}
                    inactive={object.order === 1}
                />
                <NavArrow
                    small
                    direction={Direction.DOWN}
                    onClick={onEditDown}
                    inactive={object.order === lastNumber}
                />
            </div>
        </div>
    )
};
